<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">抢购</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>项目列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <create @refresh="getProjectList"></create>
        <baseConfig></baseConfig>
        <!-- <set-percent></set-percent> -->
        <div class="change">
          刷新抢购额度：
          <el-select v-model="updated" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-button @click="update" type="primary">刷新</el-button>
        </div>
        <search-amount></search-amount>
      </div>
      <list @refresh="getProjectList"></list>
    </el-card>
  </div>
</template>

<script>
import './store';
import { mapState, mapActions } from 'vuex';
import Create from './components/create';
import List from './components/list';
import baseConfig from './components/baseConfig';
import SetPercent from './components/setpercent';
import SearchAmount from './components/searchAmount';

export default {
  name: 'foundationProject',
  data() {
    return {
      options: [
        {
          value: '1',
          label: '邀请额度'
        },
        {
          value: '2',
          label: 'USDT额度'
        },
        {
          value: '3',
          label: 'FBS额度'
        },
        {
          value: '4',
          label: '全部额度'
        }
      ],
      updated: ''
    };
  },
  components: {
    List,
    Create,
    baseConfig,
    SetPercent,
    SearchAmount
  },
  computed: {
    ...mapState('foundationProject', ['pagination'])
  },
  methods: {
    ...mapActions('foundationProject', [
      'getList',
      'getCoinTypeList',
      'freshData'
    ]),
    getProjectList(data = {}) {
      this.getList({
        ...this.pagination,
        ...data
      });
    },
    update() {
      this.freshData({ target: this.updated }).then(() => {
        this.updated = '';
      });
    }
  },
  created() {
    this.getProjectList();
    this.getCoinTypeList();
  }
};
</script>
<style lang="less" scoped>
.change {
  ::v-deep .el-button {
    margin-left: 20px;
  }
}
</style>
